import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export const CustomCursor = () => {
  const [variant, setVariant] = useState("default");
  const [enabled, setEnabled] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 500, damping: 40, mass: 0.6 });
  const sy = useSpring(y, { stiffness: 500, damping: 40, mass: 0.6 });

  useEffect(() => {
    const fine = window.matchMedia("(hover: hover) and (pointer: fine)");
    if (!fine.matches) return;
    setEnabled(true);

    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) => {
      const view = e.target.closest("[data-cursor='view']");
      if (view) return setVariant("view");
      const link = e.target.closest("a, button, input, textarea, .pill");
      setVariant(link ? "hover" : "default");
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, [x, y]);

  if (!enabled) return null;

  const size = variant === "view" ? 88 : variant === "hover" ? 44 : 14;

  return (
    <motion.div
      style={{ x: sx, y: sy }}
      className="fixed top-0 left-0 z-[9999] pointer-events-none"
      data-testid="custom-cursor"
    >
      <motion.div
        animate={{
          width: size,
          height: size,
          backgroundColor: variant === "view" ? "#A8512E" : "#EFEAE1",
          opacity: variant === "hover" ? 0.75 : 1,
        }}
        transition={{ type: "spring", stiffness: 400, damping: 30 }}
        className="rounded-full -translate-x-1/2 -translate-y-1/2 flex items-center justify-center"
        style={{
          border: "1.5px solid #121110",
          boxShadow: "0 0 0 1.5px rgba(239,234,225,0.9)",
        }}
      >
        {variant === "view" && (
          <motion.span
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            className="font-swash text-[#EFEAE1] text-xl"
          >
            view
          </motion.span>
        )}
      </motion.div>
    </motion.div>
  );
};

export default CustomCursor;
